exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\nbutton.btn.btn-blank {\n    background: white !important;\n    border: 1px #3e81bb solid !important;\n}\n\n\n.modal-header {\n    background: #efefef !important;\n    border-bottom: 1px solid #d0d0d0 !important;\n}\n\n.completer-input {\n    float: inherit !important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// c:/Projects/CCLibrary/Client/~/css-loader?{"sourceMap":false,"importLoaders":1}!c:/Projects/CCLibrary/Client/~/postcss-loader?{"ident":"postcss"}!c:/Projects/CCLibrary/Client/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = 3